import {Component, Inject, OnInit} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import * as moment from 'moment';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AddRefrigeratorDialogComponent} from '../add-refrigerator-dialog/add-refrigerator-dialog.component';
import {LoadingService} from '../../services/loading.service';

moment.locale('el-GR');

@Component({
  styleUrls: ['./create-refrigerator-request-dialog.component.scss'],
  templateUrl: './create-refrigerator-request-dialog.component.html'
})
export class CreateRefrigeratorRequestDialogComponent implements OnInit {
  public addedRefrigerators: any[];
  public formGroup: FormGroup;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CreateRefrigeratorRequestDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.addedRefrigerators = [];
    this.formGroup = new FormGroup({
      delivery_date: new FormControl('', Validators.required)
    });
  }

  public async ngOnInit(): Promise<any> {
      try {
      } catch (e) {

      } finally {

      }
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public deleteItem(index: number) {
    this.addedRefrigerators.splice(index, 1);
  }

  public isButtonDisabled(): boolean {
    return this.formGroup.invalid || this.addedRefrigerators.length === 0;
  }

  public async submit(): Promise<void> {
    this.loadingService.show();
    const details = this.setSubmitObjectDetails();
    const objectToSend =  {
      sale_point_id: this.data.sale_point_id,
      desired_delivery_date: this.formGroup.get('delivery_date').value,
      details
    };
    await this.commonService.insertObject('request/super_market', objectToSend);
    this.loadingService.hide();
    this.matDialogRef.close('success');
  }

  public openAddRefrigeratorDialog(): void {
    const dialogReference = this.matDialog.open(AddRefrigeratorDialogComponent, {
      data: {
        key_account_id: this.data.key_account_id
      }});
    dialogReference.afterClosed().subscribe(async (result) => {
      if (result) {
        this.setObjectDetails(result);
      }
    });
  }

  private setObjectDetails(refrigerator: any): void {
    refrigerator.led_description = refrigerator.is_led === 1 ? 'ΝΑΙ' : 'ΟΧΙ';
    let accessories = '';
    let count = 0;
    if (refrigerator.new_refrigerator_count !== null) {
      count += refrigerator.new_refrigerator_count;
    }
    if (refrigerator.used_refrigerator_count !== null) {
      count += refrigerator.used_refrigerator_count;
    }
    if (refrigerator.has_bars === 1) {
      accessories += 'Μπάρες, ';
    }
    if (refrigerator.has_caps === 1) {
      accessories += 'Καπάκι, ';
    }
    if (refrigerator.has_cases === 1) {
      accessories += 'Θήκες, ';
    }
    const lastIndex = accessories.lastIndexOf(',');
    refrigerator.accessories = accessories.slice(0, lastIndex);
    refrigerator.quantity = count;
    this.addedRefrigerators.push(refrigerator);
  }

  private setSubmitObjectDetails(): any[] {
    const details = [];
    for (const item of this.addedRefrigerators) {
      const submitObject = {
        material_id: item.refrigerator_material,
        comments: item.comments === '' ? null : item.comments,
        grade: item.category_description,
        is_led: item.is_led,
        evaluation_category_id: item.refrigerator_category,
        quantity: item.quantity,
        bars: item.has_bars,
        caps: item.has_caps,
        cases: item.has_cases,
        has_new_refrigerators: item.new_refrigerator_count !== null,
        original: {
          new: item.new_refrigerator_count !== null ? item.new_refrigerator_count : 0,
          used: item.used_refrigerator_count !== null ? item.used_refrigerator_count : 0,
        }
      };
      details.push(submitObject);
    }
    return details;
  }

  public showRefrigeratorsSection(): boolean {
    return this.addedRefrigerators.length > 0;
  }
}
